// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__3Eqyh","icon":"EnquiryForm_icon__gAsor","heading":"EnquiryForm_heading__1aRfe","field":"EnquiryForm_field__1ILGO","error":"EnquiryForm_error__Z5JIk"};